import axios from 'axios';
import authHeader from "@/service/auth-header";

class FinancialTransactionService {

    async getFinancialAccountSummary(companyId, startDate, endDate) {
        return await axios.get(`/api/financialtransaction/summary/${companyId}/${startDate}/${endDate}`, {headers: authHeader()})
    }

    async getFinancialTransactionsByCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/financialtransaction/${companyId}/type/E/${startDate}/${endDate}`, {headers: authHeader()})
    }


    async getFinancialTransactionDocumentsByCompany(companyId, startDate, endDate) {
        return await axios.get(`/api/financialtransaction/${companyId}/type/E/docs/${startDate}/${endDate}`, {headers: authHeader()})
    }

    createFinancialTransactionBatch(companyId, data) {
        return axios.post(`/api/financialtransaction/batch/${companyId}`, data, {headers: authHeader()});
    }

    createFinancialTransaction(companyId, data) {
        return axios.post(`/api/financialtransaction/${companyId}`, data, {headers: authHeader()});
    }

    updateFinancialTransaction(companyId, data) {
        return axios.put(`/api/financialtransaction/${companyId}`, data, {headers: authHeader()});
    }

    recodeFinancialTransactions(companyId, data) {
        return axios.post(`/api/financialtransaction/recode/${companyId}`, data, {headers: authHeader()});
    }

    deleteFinancialTransaction(id) {
        return axios.delete(`/api/financialtransaction/${id}`,{headers: authHeader()});
    }

}

export default new FinancialTransactionService();
